import type { StringSelectItem } from '@talos/kyoko';
import { createContext, useContext } from 'react';

export interface DealProductBuilderAssetsContextValue {
  availableUnderlyingAssets: StringSelectItem[];
  availableBorrowedAssets: StringSelectItem[];
  availableCollateralAssets: StringSelectItem[];
  otcDerivativesCollateralAssets: StringSelectItem[];
  otcLendingCollateralAssets: StringSelectItem[];
}

export const DealProductBuilderAssetsContext = createContext<DealProductBuilderAssetsContextValue | undefined>(
  undefined
);

export const useDealProductBuilderAssets = () => {
  const context = useContext(DealProductBuilderAssetsContext);
  if (!context) {
    throw new Error('useDealProductBuilderAssets must be used within a DealProductBuilderAssetsProvider');
  }
  return context;
};
